import { advisorSettlementState } from './advisor-settlement.state';
import { advisorSettlementActions } from './advisor-settlement.action';
import { advisorSettlementMutations } from './advisor-settlement.mutation';

export default {
  namespaced: true,
  state: advisorSettlementState,
  getters: {},
  actions: advisorSettlementActions,
  mutations: advisorSettlementMutations,
};
